import { Page, PageQuery } from './common.model';

export const PERMISSIONS = {
  user: 'ID_USER',
  admin: 'ADMIN',
  accountant: 'ACCOUNTANT',
  shop: 'NUTRI_SHOP',
} as const;

export const NO_PERMISSIONS = 'un_authorize' as const;

export const ALL_PERMISSIONS = Object.values(PERMISSIONS);

export type PermissionKeys = keyof typeof PERMISSIONS;
export type Permissions =
  | (typeof PERMISSIONS)[PermissionKeys]
  | typeof NO_PERMISSIONS;

export interface UserInfoBasic {
  id: number;
  fullName: string;
  username: string;
  avatar: string;
}

export interface RegionUpdateRequest {
  leadProvince: string;
  leadRegion: string;
  selfProvince: string;
  selfRegion: string;
}

export interface UserRegion {
  leadProvince: string;
  leadRegion: string;
  selfProvince: string;
  selfRegion: string;
}

export interface UserInfo extends UserInfoBasic {
  address: string | null;
  phoneNumber: string | null;
  role: Permissions;
  token: string;
  region: UserRegion;
  taxCode: string;
  cccdFront: string;
  cccdBack: string;
  email: string;
  cccd: string;
}

export interface LoginResponse {
  username: string;
  accessToken: string;
  refreshToken: string;
  token: string;
  expirationAt: number;
  expireTime: number;
}

export interface ShopInfo {
  address: string;
  avatar: string;
  id: number;
  totalProduct: number;
  shopName: string;
  averageRating: number;
}

export interface StatisticSummary {
  level: 'USER' | 'STORE';
  badge: string;
  personalAmount: number;
  directAmount: number;
  leaderAmount: number;
  totalPoint: number;
  bonusAmount: number;
}

export interface StatisticDetail {
  totalPersonalAmount: number;
  lastTermPersonalAmount: number;
  totalSystemAmount: number;
  lastTermSystemAmount: number;
  totalSystemOrder: number;
  totalLastTermOrder: number;
  details: Page<StatisticStore>;
}

export interface StatisticStore {
  username: string;
  fullname: string;
  level: string;
  totalAmount: number;
  currentTotalAmount: number;
  currentAmount: number;
  badge: string;
}

export interface Bonus {
  amount: number;
  note: string;
  type: string;
  level: string;
  flag: boolean;
  createdDate: string;
}

export interface RewardHistory {
  id: number;
  createdDate: string;
  userInfo: {
    userId: string;
    username: string;
    fullname: string;
  };
  amount: number;
  reason: string;
  status: boolean;
  type: string;
  evidenceImage: string;
  amountTNCN: number;
}

export interface RewardHistoryPageQuery extends PageQuery {
  key: string;
}

export interface GrossIncome {
  id: number;
  createdDate: string;
  userInfo: {
    userId: string;
    username: string;
    fullname: string;
  };
  amount: number;
  reason: string;
  status: boolean;
  type: string;
  evidenceImage: string;
}

export interface Bank {
  id: number;
  bankNumber: number;
  bankName: string;
  bankBranch: string;
  accountOwner: string;
}

export interface SearchUserQuery extends PageQuery {
  keyword: string;
}
